@use "../../../theme/colors";

.container {
	outline: none;
	position: relative;
	background-color: #fff;
	box-sizing: border-box;
	padding: 20px;
	width: 420px;
	max-width: 100%;
}

.subtitle {
	text-align: center;
	color: colors.$color-medium-grey;
	font-size: 14px;
	margin: 8px 0 16px;
}

.options {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.option {
	display: flex;
	align-items: baseline;
	gap: 12px;
	width: 100%;
	padding: 14px 16px;
	font: inherit;
	font-size: 16px;
	color: colors.$color-dark-grey;
	text-align: left;
	background: none;
	border: 1px solid colors.$color-light-grey;
	border-radius: 24px;
	cursor: pointer;

	&:hover {
		border-color: colors.$color-dark-grey;
		background-color: colors.$color-pink;
	}
}

.optionTitle {
	flex-grow: 1;
	font-weight: 500;
}

.optionDuration {
	font-size: 14px;
	font-style: italic;
	white-space: nowrap;
}

.optionPrice {
	font-weight: 500;
	white-space: nowrap;
}
